import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useAppSelector} from '../../store/hooks';
import {useParams} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import {Box, Container, Tab, Tabs} from '@mui/material';
import FullScreenLoadingSpinner from '../shared/FullScreenLoading';
import PageTitle from '../shared/PageTitle';
import TeamLoad from '../TeamReports/TeamLoad';
import TeamMetrics from '../TeamReports/TeamMetrics';

interface Props {}

const TeamReports: React.FC<Props> = () => {
  const {t} = useTranslation();
  const currentState = useAppSelector(state => ({
    team: state.team,
    family: state.family,
  }));
  const preferredUnits = useAppSelector(
    state => state.profile.profile?.preferredUnits,
  );

  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = useCallback(
    (_event: React.SyntheticEvent, newValue: number) => {
      setTabIndex(newValue);
    },
    [],
  );

  const {teamId} = useParams();
  const teamIdInt = parseInt(teamId || '');

  const activeTeam = (currentState?.team?.teams ?? []).filter(
    team => team.id === teamIdInt,
  );

  const title = t('navigation.pageTitle', {pageName: t('pages.teamReports')});

  if (currentState.team?.status === 'loading' || activeTeam.length !== 1) {
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <FullScreenLoadingSpinner />
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Container>
        <PageTitle>{t('pages.teamReports')}</PageTitle>
        <Box sx={{borderBottom: 1, borderColor: 'divider', mb: 2}}>
          <Tabs value={tabIndex} onChange={handleTabChange}>
            <Tab label={t('general.load')} />
            <Tab label={t('general.metrics')} />
          </Tabs>
        </Box>

        <Box hidden={tabIndex !== 0}>
          <TeamLoad teamId={teamIdInt} teamName={activeTeam[0]?.name ?? ''} />
        </Box>

        <Box hidden={tabIndex !== 1}>
          <TeamMetrics
            teamId={teamIdInt}
            teamName={activeTeam[0]?.name ?? ''}
            preferredUnits={preferredUnits}
            players={activeTeam[0]?.players ?? []}
          />
        </Box>
      </Container>
    </>
  );
};

export default TeamReports;
